export function enhanceLinkWithToken(
  href: string,
  currentLocation = window.location
) {
  // If pointing to docs, then proceed and split
  const [urlPart, hashPart] = href.split('#');
  const url = new URL(urlPart, currentLocation.origin);

  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    return href;
  }

  // If the website is external, just return it
  if (url.hostname !== window.location.hostname) {
    return href;
  }

  const token = new URLSearchParams(currentLocation.search).get('token');

  if (token) {
    url.searchParams.append('token', token);
  }

  let enhancedHref = url.pathname + url.search;
  if (hashPart) {
    enhancedHref += '#' + hashPart;
  }
  return enhancedHref;
}
